import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { CarrierSideBar } from "../CarrierReport/CarrierSideBar";
import { PERMISSIONS } from "../../../PermissionsConstants";

const Submenu = () => {
  const userPermissions = useRecoilValue(permissionsSelector);
  const { pathname } = useLocation();
  const [hover, setHover] = useState<number | undefined>(undefined);
  const index1 = CarrierSideBar.findIndex((item) => pathname === item.to);
  const eAndO = PERMISSIONS.permission_report_carrier_eandocontact_view;
  const eAndOperState =
    PERMISSIONS.permission_report_carrier_eandocontactperstate_view;

  const getClassName = (
    hover: number | undefined,
    index: number,
    index1: number
  ): string => {
    if (
      hover === index ||
      (hover !== undefined && index === hover - 1) ||
      index === 2 ||
      index1 === index + 1
    ) {
      return "rounded-l-lg";
    }
    return "border-b border-septenary border-opacity-25";
  };

  return (
    <>
      {userPermissions.includes(eAndO) ||
      userPermissions.includes(eAndOperState) ? (
        <div className="pl-4 py-4 rounded-l-lg bg-quinary">
          {CarrierSideBar.map(
            (item, index) =>
              userPermissions.includes(item.permission) && (
                <Link
                  onMouseEnter={() => setHover(index)}
                  onMouseLeave={() => setHover(undefined)}
                  className={
                    item.to === pathname
                      ? "bg-white rounded-l-lg text-secondary flex items-center font-medium p-2 sidebar-text-size"
                      : `flex items-center text-white bg-quinary sidebar-text-size
                          ${getClassName(
                            hover,
                            index,
                            index1
                          )} hover:bg-secondary p-2 sidebar-text-size`
                  }
                  to={item.to}
                  key={item.to}
                >
                  {item.title}
                </Link>
              )
          )}
        </div>
      ) : (
        ""
      )}
    </>
  );
};
export default Submenu;
